import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  return <section className="relative bg-navy text-white pt-20 pb-24 overflow-hidden" data-id="element-42">
      {/* Subtle background pattern/glow could go here if needed, keeping it clean for now */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-43">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-44">
          <div className="order-2 lg:order-1" data-id="element-45">
            <FadeIn data-id="element-46">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-47">
                Recupera tu Libertad Financiera:{' '}
                <span className="text-gold" data-id="element-48">Borra tu Mal Crédito</span> en USA
                sin Pagarle a Abogados
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-49">
              <div className="w-24 h-1 bg-gold mb-6" data-id="element-50"></div>
              <h2 className="text-xl md:text-2xl text-gray-300 font-sans font-light mb-10 leading-relaxed" data-id="element-51">
                El "Mapa de Limpieza" paso a paso para eliminar colecciones,
                pagos tarde y deudas médicas de tu reporte en 90 días o menos.
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-52">
              <div className="space-y-4" data-id="element-53">
                <Button fullWidth className="md:w-auto md:px-12" onClick={() => document.getElementById('offer')?.scrollIntoView({
                behavior: 'smooth'
              })} data-id="element-54">
                  Quiero Mi Clean Slate Para Mejorar Mi Crédito
                </Button>
                <p className="text-sm text-gray-400 font-sans flex items-center justify-center md:justify-start gap-2" data-id="element-55">
                  <svg className="w-4 h-4 text-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-56">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-57" />
                  </svg>
                  Descarga instantánea. Pago seguro de una sola vez.
                </p>
              </div>
            </FadeIn>
          </div>

          <div className="order-1 lg:order-2" data-id="element-58">
            <FadeIn delay={0.3} direction="left" data-id="element-59">
              <div className="relative mx-auto max-w-md lg:max-w-full" data-id="element-60">
                {/* Decorative element behind image */}
                <div className="absolute inset-0 bg-gold/20 rounded-3xl blur-3xl transform -rotate-6 scale-105" data-id="element-61"></div>
                <img src="https://cdn.magicpatterns.com/uploads/xdEB2GW5tNAhCX5EDD39G7/private_openrouter-generated-image-1773360440627.png" alt="Clean Slate Product Mockup on Phone" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl border border-navy-light" data-id="element-62" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}